import { frontendURL } from 'dashboard/helper/URLHelper';

const SettingsContent = () => import('../Wrapper.vue');
const Workflows = () => import('./Index.vue');
const WorkflowEditor = () => import('./WorkflowEditor.vue');

export default {
  routes: [
    // Workflows used to live under /settings/. Anyone who bookmarked one, or was sent a link
    // to one, still lands on it.
    {
      path: frontendURL('accounts/:accountId/settings/workflows'),
      redirect: to => frontendURL(`accounts/${to.params.accountId}/workflows`),
    },
    {
      path: frontendURL('accounts/:accountId/settings/workflows/:workflowId'),
      redirect: to =>
        frontendURL(
          `accounts/${to.params.accountId}/workflows/${to.params.workflowId}`
        ),
    },
    {
      path: frontendURL('accounts/:accountId/workflows'),
      component: SettingsContent,
      // The editor is a sub-page, so the header swaps its icon for a back button there.
      props: params => ({
        headerTitle: 'WORKFLOWS.HEADER',
        icon: 'merge',
        showBackButton: params.name === 'workflows_edit',
      }),
      children: [
        {
          path: '',
          name: 'workflows_list',
          component: Workflows,
          roles: ['administrator'],
        },
        {
          path: ':workflowId',
          name: 'workflows_edit',
          component: WorkflowEditor,
          props: true,
          roles: ['administrator'],
        },
      ],
    },
  ],
};
